import { ICenterSectionSlide } from './models';

export const getCenterSectionImgAlt = (slide: ICenterSectionSlide): string =>
  `Image showing the Guide:Human ${slide.title.slice(1).toLocaleLowerCase()} flow`;
